<template>
    <div class="roma-page-content fill-height grey lighten-4">
        <v-container>
            <EvaluationsHeader title="Por revisar" />
            <EvaluationsContent :items="4" />
        </v-container>
    </div>
</template>

<script>
import EvaluationsHeader from "@/components/evaluations/EvaluationsHeader";
import EvaluationsContent from "@/components/evaluations/EvaluationsContent";
export default {
    components: {
        EvaluationsHeader,
        EvaluationsContent
    }
};
</script>

<style></style>
